// app/javascript/controllers/admin_room_tabs_controller.js
import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "adminCurrentRoomId"

export default class extends Controller {
  static values  = { currentRoomId: Number }
  static targets = [ "list" ]

  connect() {
    const stored = Number(sessionStorage.getItem(STORAGE_KEY))
    if (!Number.isNaN(stored) && stored > 0) this.currentRoomIdValue = stored

    if (this.hasListTarget) {
      this.observer = new MutationObserver(() => this.deferSync())
      this.observer.observe(this.listTarget, { childList: true })
    }
    this.deferSync()
  }

  disconnect() { this.observer?.disconnect() }

  select(e) {
    const row = e.currentTarget.closest("[data-room-id]");   // <- find the row
    const id  = Number(row?.dataset.roomId);                 // <- read from row
    if (!Number.isNaN(id)) {
      this.currentRoomIdValue = id;
      sessionStorage.setItem(STORAGE_KEY, String(id));
      this.applyHighlight();
    }
  }
  
  openExternal(event) {
    event.stopPropagation()
    if (event.preventDefault) event.preventDefault()
    const url = event.currentTarget?.dataset?.url
    if (url) window.open(url, "_blank", "noopener")
  }


  // Prevent nested <a> click when pressing the close button
  stop(e) {
    e.preventDefault()
    e.stopPropagation()
    // submit the button_to form manually (Turbo will send PATCH + turbo-stream)
    e.currentTarget.closest("form")?.requestSubmit()
  }

  onFrameLoad(e) { if (e?.target?.id === "chat_panel") this.deferSync() }
  onStreamRender() { this.deferSync() }

  deferSync() {
    cancelAnimationFrame(this._raf || 0)
    this._raf = requestAnimationFrame(() => this.applyHighlight())
  }

  applyHighlight() {
    const links = Array.from(this.element.querySelectorAll("[data-room-id]"))
    links.forEach(a => {
      const isActive = Number(a.dataset.roomId) === this.currentRoomIdValue
      a.setAttribute("aria-selected", String(isActive))
      a.tabIndex = isActive ? 0 : -1

      if (isActive) {
        a.classList.add("bg-slate-50", "text-slate-900", "border-slate-900")
        a.classList.remove("text-slate-700", "border-transparent")
      } else {
        a.classList.remove("bg-slate-50", "text-slate-900", "border-slate-900")
        a.classList.add("text-slate-700", "border-transparent")
      }
    })
  }
}
